import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { SchoolProvider } from './contexts/SchoolContext';
import { OrgBrandingProvider } from './contexts/OrgBrandingContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { EnterprisePoolNotifier } from './components/EnterprisePoolNotifier';
import { OrgWelcomeModal } from './components/OrgWelcomeModal';
import { reloadOnceForStaleChunk } from './utils/chunkReload';

// Stale-chunk recovery. After a deploy the previous build's hashed JS chunks are
// gone from the server, so an open tab that lazy-loads a view (e.g. clicking the
// XP tab) fetches a chunk that 404s. Vite fires `vite:preloadError` for exactly
// this — reload once (coordinated with lazyWithReload + the ErrorBoundary through a
// single shared guard) to pull the fresh bundle.
window.addEventListener('vite:preloadError', (e) => {
  e.preventDefault(); // suppress Vite's default rethrow so nothing hits the error page
  reloadOnceForStaleChunk();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <SchoolProvider>
            <OrgBrandingProvider>
              <App />
              <EnterprisePoolNotifier />
              <OrgWelcomeModal />
            </OrgBrandingProvider>
          </SchoolProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);